import {
    bindMatomoClicks,
    bindMatomoKeywordClicks,
    trackMatomoPageViews,
    trackMatomoSiteSearch
} from "./collections/matomo";

bindMatomoClicks([
    {
        selector: '.js-matomo-printWeekly',
        category: 'CTA',
        action: 'Klick',
        label: 'Speichern'
    },
    {
        selector: '.js-matomo-shareWeekly',
        category: 'CTA',
        action: 'Klick',
        label: 'Teilen'
    },
    {
        selector: '.js-matomo-showManual',
        category: 'CTA',
        action: 'Klick',
        label: 'Anleitung'
    },
    {
        selector: '.js-matomo-weeklyCTA',
        category: 'CTA',
        action: 'Klick',
        label: 'Weekly'
    },
    {
        selector: '.js-matomo-weeklyBundleCTA',
        category: 'CTA',
        action: 'Klick',
        label: 'Bundle'
    },
    {
        selector: '.js-matomo-weeklyTag',
        category: 'CTA',
        action: 'Klick',
        label: 'Tag'
    },
    {
        selector: '.js-matomo-weeklyHashtag',
        category: 'CTA',
        action: 'Klick',
        label: 'Hashtag'
    },
    {
        selector: '.js-matomo-weeklyAudio',
        category: 'CTA',
        action: 'Klick',
        label: 'Audio'
    },
    {
        selector: '.js-matomo-weeklySurvey',
        category: 'CTA',
        action: 'Klick',
        label: 'Umfrage'
    },
    {
        selector: '.js-matomo-weeklyGuide',
        category: 'CTA',
        action: 'Klick',
        label: 'Lehrkräfteguide'
    }
]);

bindMatomoKeywordClicks([
    {
        selector: '.js-matomo-filterCheckbox',
        category: 'Filter',
        action: 'Klick'
    },
    {
        selector: '.js-matomo-weeklyTitle',
        category: 'Weekly',
        action: 'Klick'
    },
    {
        selector: '.js-matomo-bundleTitle',
        category: 'Bundle',
        action: 'Klick'
    }
]);

trackMatomoPageViews([
    {
        url: '/portal/de/start/',
        title: 'Start'
    },
    {
        url: '/portal/de/unterrichtseinheiten/',
        title: 'Unterrichtseinheiten'
    },
    {
        url: '/portal/de/infografiken/',
        title: 'Infografiken'
    },
    {
        url: '/portal/de/karikaturen/',
        title: 'Karikaturen'
    },
    {
        url: '/portal/de/statistiken/',
        title: 'Statistiken'
    },
    {
        url: '/portal/de/erklaerfilme/',
        title: 'Erklärfilme'
    },
    {
        url: '/portal/de/bundles/',
        title: 'Bundles'
    }
]);

const searchResults = document.querySelector('.js-matomo-searchResults');

if (searchResults) {
    trackMatomoSiteSearch({
        keyword: searchResults.dataset.matomoKeyword,
        url: '/portal/de/suche/',
        title: 'Suche'
    });
}
